export const destructiveButtonClass =
  "!bg-err-ink !text-white hover:!bg-err-ink disabled:!bg-err-bg disabled:!text-err-ink disabled:!opacity-100";
